import axios from "axios";
import router from "@/router";
import {message} from "ant-design-vue";

const service = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 300000,
    withCredentials: true  // 如果采用token方式传递用户信息，请将本行代码屏蔽
});

service.interceptors.request.use(
    config => {
        if (!config.url.includes("/login")) {
            config.headers["accessToken"] = localStorage.getItem("fhaccessToken");
        }
        let businessType = sessionStorage.getItem("businessType");
        if (businessType != null) {
            config.headers["businessType"] = businessType
        }
        return config;
    },
    error => {
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.errorCode === "000403") {
                // message.error(response.data.errorMessage);
                router.push("/");
            }
            return response.data;
        } else {
            router.push({
                path: "/"
            });
        }
    },
    error => {
        return Promise.reject();
    }
);

export default service;
